import type React from 'react'

/**
 * Minus circle (24 × 24) — StatusBanner icon for `variant="closed"`.
 *
 * Path data is byte-identical to
 * `metro/docs/superpowers/specs/assets/stationcard-v2/icon-minus-circle.svg`
 * (Figma export). Stroke is bound to `currentColor` so the banner can
 * tint via the danger foreground token.
 */
export function IconMinusCircle(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5Z"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      <path d="M7 12H17" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  )
}
